import React from 'react';

const MissionSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container">
        {/* Mission Statement */}
        <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl shadow-xl p-8 md:p-12 max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">
            Unsere Mission
          </h2>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            "Wir entwickeln nicht nur Software - wir schaffen digitale Lösungen, 
            die Unternehmen erfolgreicher machen und Menschen das Leben erleichtern."
          </p>
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <p className="text-blue-800 font-semibold">
              💡 Unser Ziel ist es, dass jede Software-Lösung einen messbaren Mehrwert 
              für unsere Kunden schafft - sei es durch höhere Umsätze, effizientere 
              Prozesse oder bessere Kundenerfahrungen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection; 